import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function OkrList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false, label: "Select" },
        { key: "date_range", sortable: false, label: "Period Range" },
        { key: "user.name", sortable: true, label: "User" },
        { key: "manager.name", sortable: true, label: "Reporting Manager" },
        { key: "progress", sortable: false, label: "Progress" },
        // { key: "status", sortable: true, label: "Status" },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalOkrList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const employeeFilter = ref(null);
    const managerFilter = ref(null);
    const monthFilter = ref((new Date().getMonth()+1).toString());
    const yearFilter = ref(new Date().getFullYear().toString());
    const listType = ref(false);
    const completionValue = ref(0);
    const okrsMetaData = ref([]);
    const okrStatusOption = ref([]);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalOkrList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch(
        [
            currentPage,
            perPage,
            searchQuery,
            statusFilter,
            employeeFilter,
            managerFilter,
            monthFilter,
            yearFilter,
            listType,
            completionValue,
        ],
        () => {
            refetchData();
        }
    );

    const fetchOkrList = (ctx, callback) => {
        store
            .dispatch("app-okrs/fetchOkrs", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
                employee: employeeFilter.value,
                manager: managerFilter.value,
                month: monthFilter.value,
                year: yearFilter.value,
                listType: (listType.value == true)? 1:0,
                completionValue: completionValue.value,
            })
            .then(response => {
                const okr = response.data.data;
                const { total } = response.data.meta;
                okrStatusOption.value = response.data.status;

                callback(okr);
                totalOkrList.value = total;
                okrsMetaData.value = okr;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching okrs",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });

                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching okrs`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                        },
                        {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                        })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == 0) return "warning";
        if (status == 1) return "success";
        if (status == 2) return "danger";
        return "primary";
    }

    return {
        fetchOkrList,
        tableColumns,
        perPage,
        currentPage,
        totalOkrList,
        okrsMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        resolveUserStatusVariant,
        okrStatusOption,
        statusFilter,
        employeeFilter,
        managerFilter,
        monthFilter,
        yearFilter,
        listType,
        completionValue
    };
}
